//#region src/variants/variants_breadcrumbs.js
var variants_breadcrumbs_default = { default: { props: { breadcrumbs: { initialValue: [
	{
		label: "Root",
		href: "#"
	},
	{
		label: "Section",
		href: "#"
	},
	{
		label: "Section",
		href: "#"
	},
	{
		label: "Section",
		href: "#"
	},
	{
		label: "Current Page",
		href: "#",
		selected: true
	}
] } } } };
//#endregion
export { variants_breadcrumbs_default as default };

//# sourceMappingURL=variants_breadcrumbs.js.map